export default __webpack_public_path__ + "static/media/404.736b664a.png";